var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBarsSolid = function SvgSvgBarsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.25 18.753a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5zM2.25 12.753a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5zM2.25 6.753a.75.75 0 0 1 0-1.5h19.5a.75.75 0 0 1 0 1.5z"
  })));
};
export default SvgSvgBarsSolid;